import { 
    apiRequest,
    AwardCreate,
    AwardTypeList,
    AwardEmployeeList
} from '../../../../../services/adapters/kepegawaian/penghargaanService'
class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest('post', AwardCreate, {
            body: query
        }, true)
    }

    fetchType = async (query, cancelToken) => {
        return await apiRequest('get', AwardTypeList, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
 
    fetchEmployeeList = async (query) => {
        return await apiRequest("get", AwardEmployeeList, {
            params: query
        }, true)
    }


}

export default CreateRepository;